import React from 'react';
import styles from './Descricao.module.css';

type DescricaoProps = {
    children: React.ReactNode;
    style?: React.CSSProperties;
};

const Descricao = ({ children, style }: DescricaoProps) => {
    return (
        <div className={styles.container} style={style}>{children}</div>
    );
};

export default Descricao;